/* eslint-disable no-param-reassign */
import produce from 'immer';

import { LOAD_SUBLEVEL1_REQUEST, LOAD_SUBLEVEL2_REQUEST, RESET_SUBLEVEL1_REQUEST, RESET_SUBLEVEL2_REQUEST } from '../actions/sublevelAction';

const initialState = {
  sublevels1: null,
  sublevels2: null
};

const sublevelReducer = (state = initialState, action) => {
  switch (action.type) {

    case LOAD_SUBLEVEL1_REQUEST:
    case RESET_SUBLEVEL1_REQUEST: {
      const { sublevels1 } = action.payload;
      return produce(state, (draft) => {
        draft.sublevels1 = sublevels1;
      });
    }

    case LOAD_SUBLEVEL2_REQUEST:
    case RESET_SUBLEVEL2_REQUEST: {
      const { sublevels2 } = action.payload;
      return produce(state, (draft) => {
        draft.sublevels2 = sublevels2;
      });
    }

    default: {
      return state;
    }
  }
};

export default sublevelReducer;
